import { render, staticRenderFns } from "./NodeTree.vue?vue&type=template&id=2a4a0af0&scoped=true"
import script from "./NodeTree.vue?vue&type=script&lang=js"
export * from "./NodeTree.vue?vue&type=script&lang=js"
import style0 from "./NodeTree.vue?vue&type=style&index=0&id=2a4a0af0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4a0af0",
  null
  
)

export default component.exports